<template>
  <div v-bind:class="signupFlipped ? 'flip-container flipped': 'flip-container'">
    <div class="flipper">
        <div class="front">
            <slot name="front"></slot>
            <v-card  elevation=6 class="signup-card">
              <v-card-title id="front-title" :style="cssVars"> {{ cardTitle }}</v-card-title>
              <v-card-text> Enter your email address. </v-card-text>
              <v-card-text>
                <v-text-field
                  id='email-input'
                  ref='emailInput'
                  v-model="email"
                  placeholder="lori@redskydesigns.com"
                  label="Email Address"
                  :color="colorFrontMain"
                  outlined
                  :rules="[rules.required, rules.email]"
                  prepend-inner-icon="mdi-email"
                  :loading='localLoading'
                >
                  <template v-slot:append-outer>
                    <v-btn id="submit-email" :style="cssVars" class="appended-icon" icon rounded dark @click="submitEmail">
                      <v-icon> mdi-chevron-right </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-card-text>
              <!-- <div id="sign-in-promo">
                <v-divider />
                <v-card-actions>
                  <v-layout row >
                    <v-flex>
                      <v-btn text rounded :style="cssVars" class="front-btn font-weight-regular" @click="$router.push('/authentication/phone/' + newUser)">
                        {{newUser ? 'Phone Sign-up' : 'Phone Sign-in'}}
                      </v-btn>
                    </v-flex>
                    <v-flex>
                      <v-btn text rounded :style="cssVars" class="front-btn font-weight-regular" @click="$router.push('/authentication/email/' + !newUser)" >
                        {{newUser ? 'Returning User' : 'Create Account'}}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </div> -->
            </v-card>
        </div>
        <div class="back">
            <slot name="back"></slot>
            <v-card elevation=6 class="signup-card">
              <v-card-title id="back-title" :style="cssVars"> Password </v-card-title>
              <v-card-text> Enter a secure password <br> Must be at least 8 characters. </v-card-text>
              <v-card-text>
                <v-text-field
                  id='password-input'
                  ref='passwordInput'
                  v-model="password"
                  label="Password"
                  :color="colorBackMain"
                  outlined
                  :rules="[rules.required, rules.password]"
                  type="password"
                  prepend-inner-icon="mdi-lock"
                  :loading='localLoading'
                >
                  <template v-slot:append-outer>
                    <v-btn id="submit-password" :style="cssVars" class="appended-icon" icon rounded dark @click="submitPassword">
                      <v-icon> mdi-chevron-right </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-card-text>
              <div id="sign-in-promo">
                <v-divider />
                <v-card-actions>
                  <v-layout row >
                    <v-flex>
                      <v-btn text rounded :style="cssVars" class="back-btn font-weight-regular" @click="signupFlipped = !signupFlipped">
                        Back
                      </v-btn>
                    </v-flex>
                    <v-flex>
                      <v-btn id='forgot-btn' text rounded :style="cssVars" class="back-btn font-weight-regular" :disabled="!email">
                        Forgot Password
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </div>
            </v-card>
        </div>
    </div>
  </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

import { mask } from 'vue-the-mask'
import { firebase } from '@/utils/firebase'

export default {
  name: 'authCard',
  directives: {
    mask,
  },
  props: {
    titleFront: String,
    newUser: Boolean,
    colorFrontMain: String,
    colorFrontLight: String,
    colorBackMain: String,
    colorBackLight: String, 
    onSuccessPath: String, //Vuex path to push to if successful
  },
  data () {
    return {

      signupFlipped: false,
      localLoading: false,

      email: null,
      password: null,

      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        password: value => (value != null ? value.trim().length >= 8 : false) || 'Must be at least 8 characters, no spaces.',
      }
    }
  },
  mounted() {

  },
  computed: {
    ...mapGetters({
        debug: 'getDebug',
        loading: 'getLoading',
        isLogged: 'getIsLogged'
    }),
    cardTitle: function () {
      return this.newUser ? 'Create Account' : 'Welcome Back!'
    },
    cssVars() {
      return {
        '--color-front-main': this.colorFrontMain,
        '--color-front-light': this.colorFrontLight,
        '--color-back-main': this.colorBackMain,
        '--color-back-light': this.colorBackLight,
      }
    }
  },
  methods: {
    submitEmail: async function() {
      this.localLoading = true
      if(this.$refs.emailInput.validate(true)) this.signupFlipped = true
      this.localLoading = false
    },
    submitPassword: async function() {
      this.localLoading = true
      let self = this
      if(this.$refs.passwordInput.validate(true) && this.$refs.emailInput.validate(true)) {
        if(this.newUser) {
          firebase.auth().createUserWithEmailAndPassword(this.email.trim(), this.password.trim())
          .then(() => {
            if(self.debug){ console.log('Successful new email user')}
          })
          .catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            if(self.debug) console.error('Error signing up with email and password')
            if(self.debug) console.error('Error', errorCode, errorMessage)
            // ...
          });
        } else {
          firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            if(self.debug) console.log('Successful new email user')
          })
          .catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            if(self.debug) console.error('Error logging in with email and password')
            if(self.debug) console.error('Error', errorCode, errorMessage)
            // ...
          });
        }
        
      } else {
        if(self.debug) console.error('Email or password did not pass requirements')
      }
      this.localLoading = false
    },
  } 
}
</script>


<style scoped>

.signup-card {
  height: auto;
  max-height: 300px;
  width: 100%;
  max-width: 600px;
  border-radius: 15px;
  padding: 2px;
}

#email-input {
  margin-top: 10px;
}

#submit-email {
  color: var(--color-front-main) 
}

#password-input {
  margin-top: 10px;
}

#submit-password {
  color: var(--color-back-main) 
}

.appended-icon {
  position: relative;
  left: 50%;
  margin-right: 50%;
  transform: translate(-50%, -15%);
}

#front-title {
  margin-bottom: 10px;
  color: var(--color-front-main) 
}

.front-btn {
  color: var(--color-front-light)  
}

#back-title {
  margin-bottom: 10px;
  color: var(--color-back-main) 
}

.back-btn {
  color: var(--color-back-light)  
}

</style>

<style type='text/css' scoped>
/* Card flip animation */

i.frontFlipBtn,
i.backFlipBtn {
    position:absolute; 
    right: 20px; 
    top: 20px;
    color:#FFFFFF;
}
i.backFlipBtn {
    -webkit-transform: rotateY(-180deg);
    -moz-transform: rotateY(-180deg);
    -o-transform: rotateY(-180deg);
    -ms-transform: rotateY(-180deg);
    transform: rotateY(-180deg);
}
.flip-container {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
}
.flip-container {
  min-height: 120px;
}
.flipper {
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  position: relative;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.6s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.6s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.6s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.6s;
  -ms-transform-style: preserve-3d;
  transition: 0.6s;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  width: 100%;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  position: absolute;
}
.flip-container.flipped .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.front {
  z-index: 2;
}
</style>